import { Dispatch, SetStateAction, createContext } from 'react'

export type DateInterval = {
  label?: string
  name?: string
  startDate?: string
  finalDate?: string
  startHour?: string
  finalHour?: string
}

type CalendarFiltersTypes = {
  feedbackDateString: string
  dateFilterType: string
  setDateFilterType: Dispatch<SetStateAction<string>>
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
  selectedDateInterval?: DateInterval
  setSelectedDateInterval: Dispatch<SetStateAction<DateInterval>>
  startDate: string
  setStartDate: Dispatch<SetStateAction<string>>
  finalDate: string
  setFinalDate: Dispatch<SetStateAction<string>>
  startHour: string
  setStartHour: Dispatch<SetStateAction<string>>
  finalHour: string
  setFinalHour: Dispatch<SetStateAction<string>>
  onSubmitCalendar: () => void
  modalTitle: string
}

const defaultValues = {
  feedbackDateString: '',
  dateFilterType: '',
  setDateFilterType: () => {},
  isOpen: false,
  onClose: () => {},
  onOpen: () => {},
  selectedDateInterval: {},
  setSelectedDateInterval: () => {},
  startDate: '',
  setStartDate: () => {},
  finalDate: '',
  setFinalDate: () => {},
  startHour: '',
  setStartHour: () => {},
  finalHour: '',
  setFinalHour: () => {},
  onSubmitCalendar: () => {},
  dateIntervals: '',
  modalTitle: '',
}

const CalendarFiltersContext = createContext<CalendarFiltersTypes>(defaultValues)

export default CalendarFiltersContext
